import Vue from 'vue'
import App from './App.vue'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import router from './router.js';
import vueSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import '../../common/commStyle/newChange.css';
import '../../common/commStyle/style1.css';
// import '../../common/commStyle/bootstrap.css';
import '../../common/commStyle/main.css';
import '../../common/commStyle/portal/indexa.css';
// import '../../common/commStyle/portal/indexc.css';
Vue.config.productionTip = false
Vue.use(iView);
Vue.use(vueSwiper, /* { default global options } */ )

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')